"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSummaryInputs = exports.setSummarySupported = exports.setBuildRef = exports.setTmpDir = exports.summaryInputs = exports.isSummarySupported = exports.buildRef = exports.tmpDir = void 0;
const core = __importStar(require("@actions/core"));
const build_1 = require("@docker/actions-toolkit/lib/buildx/build");
exports.tmpDir = process.env['STATE_tmpDir'] || '';
exports.buildRef = process.env['STATE_buildRef'] || '';
exports.isSummarySupported = !!process.env['STATE_isSummarySupported'];
exports.summaryInputs = process.env['STATE_summaryInputs'] ? JSON.parse(process.env['STATE_summaryInputs']) : undefined;
function setTmpDir(tmpDir) {
    core.saveState('tmpDir', tmpDir);
}
exports.setTmpDir = setTmpDir;
function setBuildRef(buildRef) {
    core.saveState('buildRef', buildRef);
}
exports.setBuildRef = setBuildRef;
function setSummarySupported() {
    core.saveState('isSummarySupported', 'true');
}
exports.setSummarySupported = setSummarySupported;
function setSummaryInputs(inputs) {
    const res = {};
    for (const key of Object.keys(inputs)) {
        if (key === 'github-token') {
            continue;
        }
        const value = inputs[key];
        if (typeof value === 'boolean' && !value) {
            continue;
        }
        else if (Array.isArray(value)) {
            if (value.length === 0) {
                continue;
            }
            else if (key === 'secrets' && value.length > 0) {
                const secretKeys = [];
                for (const secret of value) {
                    try {
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        const [skey, _] = build_1.Build.parseSecretKvp(secret, true);
                        secretKeys.push(skey);
                    }
                    catch (err) {
                        // ignore invalid secret
                    }
                }
                if (secretKeys.length > 0) {
                    res[key] = secretKeys;
                }
                continue;
            }
        }
        else if (!value) {
            continue;
        }
        res[key] = value;
    }
    core.saveState('summaryInputs', JSON.stringify(res));
}
exports.setSummaryInputs = setSummaryInputs;
